import { IS_DE_LANG_ENV } from '../config/env';

export const ReferenceCategory = {
    ALL: 'all',
    FINANCE: 'finance',
    E_COMMERCE: 'ecommerce',
    TRAVEL: 'travel',
    DELIVERY: 'delivery',
    ...(!IS_DE_LANG_ENV &&
        ({
            NEWS: 'news',
        } as const)),
    DIGITALIZATION: 'digitalization',
} as const;
